import React, { useEffect, useState } from 'react'
import { Card, Input, Cascader, Button, Table, Space, Pagination, Form } from 'antd'
import { BookOutlined, StarFilled } from '@ant-design/icons'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { getDistrictListAPI } from '@/apis/common'
import { getClueHouseListAPI } from '@/apis/user'
import { checkMenu, checkLogin } from '@/utils'
const { Column } = Table

export default function ClueHouseList() {
  const navigate = useNavigate()
  const location = useLocation()
  const [listLoading, setListLoading] = useState(false) //  表格加载状态
  //  列表请求参数
  const [listQuery, setListQuery] = useState({
    keywords: '',
    districtId: 0,
    plateIds: [],
    pageInt: 1,
    pageSize: 10
  })
  const [total, setTotal] = useState(0) //  列表总数
  const [mainHouseIds, setMainHouseIds] = useState([]) //  列表总数
  const [districtList, setDistrictList] = useState([]) // 区域板块列表
  //  获取线索楼盘列表
  const [list, setList] = useState()

  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    fetchData()
  }
  //  搜索
  const searchFinish = values => {
    console.log('%c [ values ]-78', 'font-size:13px; background:pink; color:#bf2c9f;', values)
    listQuery.keywords = values.keywords
    let districtId = 0
    let plateIds = []
    if (values.plateIds) {
      values.plateIds.forEach(item => {
        if (item.length > 1) {
          districtId = item[0]
          plateIds.push(item[1])
        } else {
          districtId = item[0]
        }
      })
    }
    listQuery.districtId = districtId
    listQuery.plateIds = plateIds
    listQuery.pageInt = 1
    setListQuery({
      ...listQuery
    })
    fetchData()
  }

  //  获取楼盘列表
  const fetchData = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    setListLoading(true)
    const res = await getClueHouseListAPI(listQuery)
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.key = index
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
      setMainHouseIds(res.result.mainHouseId)
      setListLoading(false)
    }
  }
  //  分类
  const dealData = (array, parentId = 0) => {
    let list = []
    array.forEach(item => {
      if (parentId == item.parentId) {
        let data = {}
        data.label = item.name
        data.value = item.id
        if (item.parentId === 0) {
          data.children = dealData(array, item.id)
        }
        list.push(data)
      }
    })
    if (list.length > 1) {
      list.unshift({ label: '不限', value: 0 })
    }
    return list
  }

  //  获取区域板块列表
  const getDistrictList = async () => {
    const res = await getDistrictListAPI()
    if (res.success === true) {
      if (res.result) {
        let districtList = dealData(res.result, 0)
        setDistrictList(districtList)
      }
    }
  }

  useEffect(() => {
    if(!checkMenu(location.pathname)) {
      navigate('/managecenter/404')
      return
    }
    fetchData()
    getDistrictList()
  }, [])

  return (
    <div>
      <div className="pageTitle flex-between">
        <div>楼盘客资</div>
        <div className='font-size14 font-normal'>
          <Link target="_blank" to="https://docs.qq.com/slide/DZW1PdnNUYVNTcWdr" className="black">
            <BookOutlined />
            <span className='margin-left-10'>操作手册</span>
          </Link>
          
        </div>
      </div>
      <Card className="card">
        <Form initialValues={listQuery} onFinish={searchFinish} className="searchForm">
          <Form.Item name="keywords">
            <Input allowClear placeholder="楼盘名关键词" style={{ width: '200px' }} />
          </Form.Item>
          <Form.Item name="plateIds">
            <Cascader allowClear multiple placeholder="区域-板块" options={districtList} style={{ width: '200px', marginLeft: '10px' }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="searchBtn" htmlType="submit" style={{ marginLeft: '10px' }}>
              搜索
            </Button>
          </Form.Item>
        </Form>
        <Table dataSource={list} loading={listLoading} pagination={false}>
          <Column
            title="楼盘名"
            dataIndex="name"
            render={(_, record) => (
              <Space size="middle">
                {mainHouseIds.indexOf(record.id) > -1 && <StarFilled style={{ color: '#FFC300' }} />}
                {record.name}
              </Space>
            )}
          />
          <Column title="区域" dataIndex="districtName" />
          <Column title="板块" dataIndex="plateName" />
          <Column title="参考价" dataIndex="price" />
          <Column title="7日独立客资" dataIndex="weekVisitorNum" />
          <Column title="30天独立客资" dataIndex="monthVisitorNum" className="red" />
          <Column title="90天独立客资" dataIndex="quarterVisitorNum" />
          <Column title="180天独立客资" dataIndex="halfYearVisitorNum" />
          <Column
            title="操作"
            key="action"
            render={(_, record) => (
              <Space size="middle">
                <Link target="_blank" to={'/managecenter/user/cluehouseuserlist/' + record.id + '/' + record.name} className="color-576b95">
                  客资明细
                </Link>
              </Space>
            )}
          />
        </Table>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
      </Card>
    </div>
  )
}
